import React from 'react';
import { connect } from 'react-redux';
import type { State } from '@helpcenter/common-state-selectors';
import { isLoggedIn as isUserLoggedIn } from '@helpcenter/common-state-selectors/src/user';
import { AsyncHeartbeat } from './async';

export const redirectToLoginOnHeartbeatError = () => {
	const pathSegments = window.location.pathname.split('/').filter(Boolean);
	if (pathSegments.includes('login')) return;
	if (pathSegments.includes('helpcenter-management')) {
		window.location.href = `/servicedesk/customer/user/login`;
		return;
	}

	const path = window.location.pathname + window.location.search;
	const match = path.match(/\/portal\/(\d+)/);
	const portalId = match ? Number(match[1]) : undefined;

	const basePath = pathSegments.slice(0, 2).join('/');
	const loginBasePath = portalId
		? `/${basePath}/portal/${portalId}/user/login`
		: `/${basePath}/user/login`;
	const destination = pathSegments.slice(2).join('/');

	window.location.href = `${loginBasePath}?destination=${encodeURIComponent(destination + window.location.search)}`;
};

export const DumbHeartbeat = ({ isLoggedIn }: { isLoggedIn: boolean }) => {
	return isLoggedIn ? (
		<AsyncHeartbeat
			idleTime={20 * 60 * 1000} // 20 minutes
			onAuthenticationFailed={redirectToLoginOnHeartbeatError}
		/>
	) : null;
};

export const Heartbeat = connect((state: State) => {
	return {
		isLoggedIn: isUserLoggedIn(state),
	};
})(DumbHeartbeat);
